import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import invariant from 'react-utils/invariant';
import { isOperator } from 'customer-data-filters-ui/filterQueryFormat/operator/Operator';
import { MissingAssociationBranchFilter, PrivacyConsentCompleted, PrivacyConsentNotCompleted } from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import toAdsFilter from './toObjectSegFilter/toAdsFilter';
import toCtaFilter from './toObjectSegFilter/toCtaFilter';
import toConstantFilter from './toObjectSegFilter/toConstantFilter';
import toEmailEventFilter from './toObjectSegFilter/toEmailEventFilter';
import toEmailSubscriptionFilter from './toObjectSegFilter/toEmailSubscriptionFilter';
import toEventFilter from './toObjectSegFilter/toEventFilter';
import toFormSubmissionFilter from './toObjectSegFilter/toFormSubmissionFilter';
import toIntegrationFilter from './toObjectSegFilter/toIntegrationFilter';
import toListMembershipFilter from './toObjectSegFilter/toListMembershipFilter';
import toPageViewFilter from './toObjectSegFilter/toPageViewFilter';
import toPrivacyConsentFilter from './toObjectSegFilter/toPrivacyConsentFilter';
import toPropertyFilter from './toObjectSegFilter/toPropertyFilter';
import toSurveyMonkeyQuestionFilter from './toObjectSegFilter/toSurveyMonkeyQuestionFilter';
import toSurveyMonkeySurveyFilter from './toObjectSegFilter/toSurveyMonkeySurveyFilter';
import toWebinarFilter from './toObjectSegFilter/toWebinarFilter';
import { getDynamicFilterFamilyBasis } from 'customer-data-filters-ui/filterQueryFormat/DynamicFilterFamilies';
import DeprecatedFilter from 'customer-data-filters-ui/filterQueryFormat/operator/DeprecatedFilter';
import * as ObjectSegConstants from './constants/constants';
import { isPropertyChangedEventTypeId, isPropertyNameAndValueCondition } from '../../strategy/propertyChangedFilterUtils';
import { toPropertyNameAndValueFilter } from './toObjectSegFilter/toPropertyNameAndValueFilter';
import toCommunicationSubscriptionFilter from './toObjectSegFilter/toCommunicationSubscriptionFilter';
import toMissingAssociationFilter from './toObjectSegFilter/toMissingAssociationFilter';
import { getConverterOptionsWithDefaults } from './converterOptions';
const filterFamilyConverters = {
  [DSAssetFamilies.ADS_PROPERTY]: toAdsFilter,
  [DSAssetFamilies.CTA]: toCtaFilter,
  [ObjectSegConstants.DEPRECATED_FILTER]: toConstantFilter,
  [ObjectSegConstants.MISSING_ASSOCIATION_BRANCH_FILTER]: toMissingAssociationFilter,
  [DSAssetFamilies.EMAIL_CAMPAIGN]: toEmailEventFilter,
  [DSAssetFamilies.EMAIL_SUBSCRIPTION]: toEmailSubscriptionFilter,
  [DSAssetFamilies.SMS_SUBSCRIPTION]: toCommunicationSubscriptionFilter,
  [DSAssetFamilies.WHATSAPP_SUBSCRIPTION]: toCommunicationSubscriptionFilter,
  [DSAssetFamilies.EVENT]: toEventFilter,
  [DSAssetFamilies.FORM]: toFormSubmissionFilter,
  [DSAssetFamilies.GOTO_WEBINAR_WEBINAR]: toWebinarFilter,
  [DSAssetFamilies.IMPORT]: toListMembershipFilter,
  [DSAssetFamilies.INTEGRATION]: toIntegrationFilter,
  [DSAssetFamilies.IN_LIST]: toListMembershipFilter,
  [DSAssetFamilies.PAGE_VIEW]: toPageViewFilter,
  [DSAssetFamilies.SURVEY_MONKEY_QUESTION]: toSurveyMonkeyQuestionFilter,
  [DSAssetFamilies.SURVEY_MONKEY_SURVEY]: toSurveyMonkeySurveyFilter,
  [DSAssetFamilies.WORKFLOW]: toListMembershipFilter,
  [DSAssetFamilies.PRIVACY_CONSENT]: toPrivacyConsentFilter
};
const isPrivacyConsent = condition => {
  return condition instanceof PrivacyConsentCompleted || condition instanceof PrivacyConsentNotCompleted;
};
const getFilterFamilyBasis = (operator, filterFamily) => {
  if (isPrivacyConsent(operator)) {
    return DSAssetFamilies.PRIVACY_CONSENT;
  }
  if (operator.constructor === DeprecatedFilter) {
    return ObjectSegConstants.DEPRECATED_FILTER;
  }
  if (operator.constructor === MissingAssociationBranchFilter) {
    return ObjectSegConstants.MISSING_ASSOCIATION_BRANCH_FILTER;
  }
  return getDynamicFilterFamilyBasis(filterFamily) || filterFamily;
};

/**
 * Convert {@link https://product.hubteam.com/docs/crm-filters/legacy-docs/FilterQueryFormat/Overview.html Filter Query Format} to InboundDbListSeg filter.
 */
export const toObjectSegFilterStrict = (operator, filterFamily, isUngated, serializerOptions) => {
  invariant(isOperator(operator), `Expected ${operator} to be an operator`);
  invariant(typeof filterFamily === 'string', `Expected ${filterFamily} to be a string`);
  invariant(typeof isUngated === 'function', `Expected ${isUngated} to be a function`);
  const converterOptions = getConverterOptionsWithDefaults({
    isUngated,
    useHoursFiltering: serializerOptions && serializerOptions.useHoursFiltering
  });
  const filterFamilyBasis = getFilterFamilyBasis(operator, filterFamily);
  if (Object.prototype.hasOwnProperty.call(filterFamilyConverters, filterFamilyBasis)) {
    return filterFamilyConverters[filterFamilyBasis](operator, filterFamily, converterOptions);
  }
  if (isPropertyChangedEventTypeId(filterFamily) && isPropertyNameAndValueCondition(operator)) {
    return toPropertyNameAndValueFilter(operator, converterOptions);
  }
  return toPropertyFilter(operator, converterOptions);
};